import { render, staticRenderFns } from "./form-cliente.vue?vue&type=template&id=450f007b&"
import script from "./form-cliente.vue?vue&type=script&lang=js&"
export * from "./form-cliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports